// extracted by mini-css-extract-plugin
export var wordContainer = "_md-0";